import {
    ArchiveFilter,
    matchesArchiveFilter,
} from "../templates/archiveFilter";

interface FilterableReportTemplate {
    name: string;
    isArchived: boolean;
}

export const filterReportTemplates = <T extends FilterableReportTemplate>({
    templates,
    search,
    archiveFilter,
}: {
    templates: T[];
    search: string;
    archiveFilter: ArchiveFilter;
}): T[] => {
    const lowerSearch = search.toLowerCase();
    return templates.filter(
        (template) =>
            template.name.toLowerCase().includes(lowerSearch) &&
            matchesArchiveFilter({
                isArchived: template.isArchived,
                archiveFilter,
            }),
    );
};
